export default __webpack_public_path__ + "static/media/tokit1.e8ec003d.png";